import React from 'react';
import styles from './styles/styles.module.css';

import { FaMagnifyingGlass } from 'react-icons/fa6';
import {
  FaRegCheckCircle,
  FaUpload,
  FaCalendarAlt,
  FaRegSave,
} from 'react-icons/fa';
import { MdOutlineTextFields } from 'react-icons/md';
import { RxDropdownMenu } from 'react-icons/rx';
import { IoMdTime } from 'react-icons/io';

import { useEditor } from '@craftjs/core';
import InputField from '../BuilderInputField/InputField';
import CheckboxField from '../Checkbox/CheckboxField';
import MultilineTextbox from '../MultilineTextbox/MultilineTextbox';
import UploadArea from '../UploadArea/UploadArea';
import DropdownField from '../DropdownField/DropdownField';
import DatePickerField from '../DatePicker/DatePicker';
import TimePickerField from '../TimePickerField/TimePickerField';

interface UIButton {
  type:
    | 'INPUT'
    | 'CHECKBOX'
    | 'TEXTBOX'
    | 'UPLOAD'
    | 'DROPDOWN'
    | 'DATE'
    | 'TIME'
    | 'SAVE';
  submitHandler?: () => void;
  loading?: boolean;
  enabled?: boolean;
}

const UIControlButton: React.FC<UIButton> = ({
  type,
  submitHandler,
  loading,
  enabled,
}) => {
  const { connectors } = useEditor();
  const isSave = type === 'SAVE';

  function renderIcon() {
    switch (type) {
      case 'INPUT':
        return <FaMagnifyingGlass size={35} />;
      case 'CHECKBOX':
        return <FaRegCheckCircle size={35} />;
      case 'TEXTBOX':
        return <MdOutlineTextFields size={35} />;
      case 'UPLOAD':
        return <FaUpload size={35} />;
      case 'DROPDOWN':
        return <RxDropdownMenu size={35} />;
      case 'DATE':
        return <FaCalendarAlt size={35} />;
      case 'TIME':
        return <IoMdTime size={35} />;
      case 'SAVE':
        return <FaRegSave color="white" size={35} />;
      default:
        return null;
    }
  }

  function renderText() {
    switch (type) {
      case 'INPUT':
        return 'Input Field';
      case 'CHECKBOX':
        return 'Checkbox';
      case 'TEXTBOX':
        return 'Textbox';
      case 'UPLOAD':
        return 'Upload Field';
      case 'DROPDOWN':
        return 'Dropdown';
      case 'DATE':
        return 'Date Picker';
      case 'TIME':
        return 'Time Picker';
      case 'SAVE':
        return 'Save Layout';
      default:
        return '';
    }
  }

  function returnField() {
    switch (type) {
      case 'INPUT':
        return <InputField placeholder="Drag Me" />;
      case 'CHECKBOX':
        return <CheckboxField />;
      case 'TEXTBOX':
        return <MultilineTextbox />;
      case 'UPLOAD':
        return <UploadArea />;
      case 'DROPDOWN':
        return <DropdownField />;
      case 'DATE':
        return <DatePickerField />;
      case 'TIME':
        return <TimePickerField />;
      default:
        return <InputField placeholder="Drag Me" />;
    }
  }

  return (
    <div
      className={enabled ? styles.wrapper : styles.wrapperInactive}
      onClick={isSave && submitHandler && !loading ? submitHandler : undefined}
      ref={
        !isSave ? (ref) => ref && connectors.create(ref, returnField()) : null
      }
      style={{
        width: isSave ? '100%' : undefined,
        cursor: isSave ? 'pointer' : undefined,
        backgroundColor: isSave ? '#1f47f4' : undefined,
        border: isSave ? '1px solid #1f47f4' : undefined,
        opacity: isSave ? '0.8' : undefined,
      }}
    >
      {renderIcon()}
      <p style={isSave ? { color: 'white' } : {}} className={styles.text}>
        {renderText()}
      </p>
    </div>
  );
};

export default UIControlButton;
